import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  replace (event) {
    const spinner = document.createElement('i')
    spinner.classList.add('fa', 'fa-spinner', 'fa-pulse', 'fa-2x', 'white-colour')
    this.element.replaceWith(spinner)
  }
}
